import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

interface NavItem {
  label: string
  href: string
}

interface HeaderProps {
  navItems?: NavItem[]
}

const defaultNavItems: NavItem[] = [
  { label: 'Dashboard', href: '/' },
  { label: 'Entities', href: '/entities' },
  { label: 'Transactions', href: '/transactions' },
  { label: 'Portfolio', href: '/portfolio' },
  { label: 'Work Orders', href: '/work-orders' },
  { label: 'Chat', href: '/chat' },
]

export function Header({ navItems = defaultNavItems }: HeaderProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, signOut } = useAuth()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  return (
    <header className="py-8 border-b border-swiss-gray-200">
      <div className="flex justify-between items-center max-w-[1440px] mx-auto px-12">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-6 h-6 bg-swiss-black flex items-center justify-center">
            <span className="text-swiss-white text-xs font-bold">D</span>
          </div>
          <span className="text-[16px] font-semibold tracking-tight">
            Derivative Admin
          </span>
        </Link>

        <div className="flex items-center gap-8">
          <nav className="flex gap-8">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={
                    isActive
                      ? 'text-[13px] text-swiss-black font-medium cursor-pointer'
                      : 'text-[13px] text-swiss-gray-500 cursor-pointer transition-colors duration-150 hover:text-swiss-black'
                  }
                >
                  {item.label}
                </Link>
              )
            })}
          </nav>

          {user && (
            <button
              onClick={handleSignOut}
              className="text-[13px] text-swiss-gray-500 cursor-pointer transition-colors duration-150 hover:text-swiss-black"
            >
              Sign Out
            </button>
          )}
        </div>
      </div>
    </header>
  )
}
